import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { PcrStaffApplicationStatisticsPage } from '../pcr-personal-space/pcr-staff-application-statistics'
import PcrCreatePage from './pcr-create'
import PcrKanbanPage from './pcr-kanban'
import PcrPayScaleCreatePage from './pcr-pay-scale-create'
import PcrPayScaleListPage from './pcr-pay-scale-list'
import PcrPayScaleUpdatePage from './pcr-pay-scale-update'
import PcrUpdatePage from './pcr-update'
import PcrsList from './pcrs-list'
import StaffApplicationsList from './staff-applications-list'
import UpdateStaffApplication from './update-staff-application'

const staffApplicationRoutes: Route[] = [
  {
    path: Paths.PCRS_PAGE,
    element: <PcrsList />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_PAY_SCALES,
    element: <PcrPayScaleListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_PAY_SCALE_CREATE_PAGE,
    element: <PcrPayScaleCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_PAY_SCALE_UPDATE_PAGE,
    element: <PcrPayScaleUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_UPDATE_PAGE,
    element: <PcrUpdatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_CREATE_PAGE,
    element: <PcrCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_KANBAN_BOARD,
    element: <PcrKanbanPage />,
    roles: [RoleEnum.ADMIN, RoleEnum.PCR]
  },
  {
    path: Paths.PCR_STATISTICS,
    element: <PcrStaffApplicationStatisticsPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PCR_PERSONAL_SPACE_KANBAN,
    element: <PcrKanbanPage />,
    roles: [RoleEnum.ADMIN, RoleEnum.PCR]
  },
  {
    path: Paths.STAFF_APPLICATIONS_PAGE,
    element: <StaffApplicationsList />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.UPDATE_STAFF_APPLICATION_PAGE,
    element: <UpdateStaffApplication />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.STAFF_APPLICATION_VIEW_PAGE,
    element: <UpdateStaffApplication readOnly />,
    roles: [RoleEnum.ADMIN, RoleEnum.PCR]
  }
]

export default staffApplicationRoutes
